import Vue from 'vue'
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex'
import { AccountLoginCredentials, AccountState, StoreState } from '@/interfaces'
import firebase from '@/firebase'

Vue.use(Vuex)

let database: any

function initialState (): AccountState {
  return {
    auth: {
      email: '',
      name: '',
      uid: ''
    },
    settings: {
      admin: false,
      gender: 'male',
      weights: 'intermediate'
    }
  }
}

const actions: ActionTree<AccountState, StoreState> = {
  initialize ({ commit, dispatch }) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        database = firebase.firestore().collection('users').doc(user.uid)

        commit('setAuthState', user)
        dispatch('fetchSettings')
      } else {
        commit('clearState')
      }
    })
  },
  async fetchSettings ({ commit }) {
    const settings = await database.get()

    if (settings) {
      commit('setSettingState', settings.data())
    }
  },
  login ({ commit }, credentials: AccountLoginCredentials) {
    return firebase.auth().signInWithEmailAndPassword(credentials.email, credentials.password)
  },
  async logout ({ commit }) {
    await firebase.auth().signOut()

    commit('clearState')

    location.reload(true)
  }
}

const getters: GetterTree<AccountState, StoreState> = {
  isAdmin (state) {
    return state.settings.admin
  },
  isLoggedIn (state) {
    return !!state.auth.uid
  }
}

const mutations: MutationTree<AccountState> = {
  clearState (state) {
    state = initialState()
  },
  setAuthState (state, payload: any) {
    state.auth.email = payload.email || ''
    state.auth.name = payload.name || ''
    state.auth.uid = payload.uid || ''
  },
  setSettingState (state, payload: any) {
    state.settings.admin = payload.admin || false
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  getters,
  mutations
}
